import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { conditionalWidth, } from "../../../utils/useful";
import Cookies from "universal-cookie";
import PageStatusViewer from "../../../components/PageStatusViewer";
import StagesManager from '../../../components/StagesManager';
import { ConnectionsPages } from '../../../variables/AppletPages';
import BoxesView from '../../../components/views/BoxesView';
import FormView from "../../../components/views/FormView";
import DashboardView from "../../../components/views/DashboardView";
import CollectionView from './CollectionView';

class ConnectionView extends Component {

    state = {
        modules: [],
        headers: []
    }

    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = Object.values(ConnectionsPages.pages)
                let accessSections = Object.values(ConnectionsPages.sections)
                this.setState({ modules: accessPages, sections: accessSections }, () => {
                    this.checkDefaultTab()
                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'ConnectionView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    componentDidUpdate(prevProps) {
        if ((this.state.oldData && this.state.oldData != this.props.windowData) || this.props.width != prevProps.width) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: false,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header?.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this?.header.forceUpdate()
                })
            }
        }
    }

    checkDefaultTab() {
        let def = ''
        let pageType = null
        let pageInfo = null
        let headers = this.state.headers
        let pathname = this.props.windowData.path//window.location.pathname.split('/')
        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]
        if (pathname.length > 3) {
            rootRef = pathname[2]
        }
        pathname.forEach((path, index) => {
            if (path == (rootRef)) {
                def = pathname[index + 1]
            }
        });
        let pageIsValid = false
        Object.values(this.state.modules).forEach(page => {
            let defaultPage = page.defaultPage
            if (conditionalWidth(this.props.width, { xs: true, sm: false })) {
                defaultPage = false
            }
            if ((page.key.toLowerCase() === def?.toLowerCase()) || ((def == '' || !def) && defaultPage)) {
                headers = page.headers
                pageIsValid = true
                pageType = page.pageType
                pageInfo = page
                this.setState({ headers })
                if ((def == '' || !def)) {
                    def = page?.key
                    this.changePage(page?.key)
                }
            }
        });
        if (!def) {
            def = ''
        }
        if (def === '') {
            pageType = ''
            pageIsValid = true
        }
        if (def === 'connections') {
            pageType = ''
            pageIsValid = true
        }
        if (pageIsValid) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.setState({ path: def, pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            this.setState({ page: pageInfo, pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else { }
                            })
                        })
                    }, 10);
                })

            })
        } else {
            this.setState({ pageStatus: 404 })
        }
    }

    changePage = (page) => {
        let path
        if (page) {
            path = [page?.key ?? page]
        }
        this.changeWindowLink(path)
    }

    changeWindowLink = (nPath) => {
        let path = this.props.windowData?.path
        path = [path[0], path[1], path[2]]
        if (nPath != null) {
            for (let i = 0; i < nPath.length; i++) {
                if (nPath[i] != path[path.length - 1]) {
                    path.push(nPath[i])
                }
            }
        }
        this.props.changeWindow(path)
    }

    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }

    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    render() {

        let variables = {
            appletId: this.props.applet?._id,
            appletHub: typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub._id : this.props.applet?.hub,
            targetId: typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub._id : this.props.applet?.hub,
        }

        return (
            <div className="h-100">
                <PageStatusViewer status={this.state.pageStatus}>
                    <div className=" w-100 h-100  window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
                        <div className='d-flex w-100 h-100'>
                            <div className="w-100 h-100 scroll-no-scrollbar window-content-radius " ref={el => this.pageContainer = el} style={{ backgroundColor: '#fff' }} >
                                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true} >
                                    <DashboardView setHeader={this.props.setHeader} baseUrl={[...this.props.baseUrl]} setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} type={'connections'} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} onClick={this.changePage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={variables} />
                                    <CollectionView stageName={'collection'} isMobile={this.props.isMobile} permissions={this.props.permissions} ref={el => this.collectionView = el} setData={this.setData} setHeader={this.props.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.state.page?.formPages} page={this.state.page} baseUrl={[...this.props.baseUrl, 'connections']} applet={this.props.applet} headers={this.state.headers} automations={this.state.automations} language={this.props.language} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={this.props.variables} />
                                    <FormView setHeader={this.props.setHeader} setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'table'} route={this.props.route} variables={variables} />
                                    <BoxesView setHeader={this.props.setHeader} setData={this.setData} applet={this.props.applet} pages={this.state.pages} width={this.props.width} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'boxes'} route={this.props.route} />
                                </StagesManager>
                            </div>
                        </div>
                    </div>
                </PageStatusViewer>
            </div>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConnectionView);
